import { useEffect, useState } from 'react'

export const useKeypress = () => {
  const [keys, setKeys] = useState({})

  const handleKeyDown = () => {
    document.body.addEventListener('keydown', onKeyDown)
    document.body.addEventListener('keyup', onKeyUp)
  }

  const handleKeyUp = () => {
    document.body.removeEventListener('keydown', onKeyDown)
    document.body.removeEventListener('keyup', onKeyUp)
  }

  useEffect(() => {
    handleKeyDown()
    return () => {
      handleKeyUp()
    }
  }, [])

  const handleKeyChange = (key, pressed) => {
    setKeys(prevKeys => {
      return { ...prevKeys, [key]: pressed }
    })
  }

  const onKeyDown = e => {
    handleKeyChange([e.key], true)
  }

  const onKeyUp = e => {
    handleKeyChange([e.key], false)
  }

  return [keys]
}
